<template>
    <div class="" v-if="appear" @click="flip = !flip">
        <transition name="flip" mode="out-in">
            <figure v-if="flip" class="bg-white shadow-md flex flex-col justify-center w-full h-full" key="front">
                <svg class="outlineAnimation" xmlns="http://www.w3.org/2000/svg"
                     viewBox="0 0 50.4 30.5"><title>print_stroke</title>
                    <g id="916efa58-89bc-48d9-8924-32db9c85a278" data-name="Layer 2">
                        <g id="a430c424-9095-481c-a6cf-ca2e51ae2849" data-name="Layer 1">
                            <polygon points="34.48 27.64 26.65 30.25 26.65 14.58 34.48 11.97 34.48 27.64"
                                     fill="none" stroke="#E3B624" stroke-linecap="round"
                                     stroke-linejoin="round" stroke-width="0.5"/>
                            <polygon points="50.15 27.64 42.32 30.25 42.32 14.58 50.15 11.97 50.15 27.64"
                                     fill="none" stroke="#E3B624" stroke-linecap="round"
                                     stroke-linejoin="round" stroke-width="0.5"/>
                            <polygon points="42.32 30.25 34.48 27.64 34.48 11.97 42.32 14.58 42.32 30.25"
                                     fill="none" stroke="#E3B624" stroke-linecap="round"
                                     stroke-linejoin="round" stroke-width="0.5"/>
                            <line x1="27.75" y1="26.08" x2="33.25" y2="24.25" fill="none" stroke="#E3B624"
                                  stroke-linecap="round" stroke-linejoin="round" stroke-width="0.5"/>
                            <line x1="32.25" y1="26.25" x2="27.75" y2="27.75" fill="none" stroke="#E3B624"
                                  stroke-linecap="round" stroke-linejoin="round" stroke-width="0.5"/>
                            <line x1="35.58" y1="16.47" x2="40.92" y2="18.25" fill="none" stroke="#E3B624"
                                  stroke-linecap="round" stroke-linejoin="round" stroke-width="0.5"/>
                            <line x1="41.25" y1="20.03" x2="35.58" y2="18.14" fill="none" stroke="#E3B624"
                                  stroke-linecap="round" stroke-linejoin="round" stroke-width="0.5"/>
                            <path d="M26.25,25.25h-25a1,1,0,0,1-1-1v-23a1,1,0,0,1,1-1h34a1,1,0,0,1,1,1v11"
                                  fill="none" stroke="#E3B624" stroke-linecap="round" stroke-linejoin="round"
                                  stroke-width="0.5"/>
                            <path d="M26.25,25.25h-25a1,1,0,0,1-1-1v-2h26" fill="none" stroke="#E3B624"
                                  stroke-linecap="round" stroke-linejoin="round" stroke-width="0.5"/>
                            <polyline
                                    points="16.36 29.25 12.25 29.25 12.25 30.25 24.25 30.25 24.25 29.25 22.25 29.25 21.25 25.25 15.25 25.25 14.25 29.25"
                                    fill="none" stroke="#E3B624" stroke-linecap="round" stroke-linejoin="round"
                                    stroke-width="0.5"/>
                            <polyline
                                    points="11.7 16.38 23.23 4.86 24.64 6.27 12.62 18.29 9.79 19.7 11.21 16.88 12.06 17.73"
                                    fill="none" stroke="#E3B624" stroke-linecap="round" stroke-linejoin="round"
                                    stroke-width="0.5"/>
                            <rect x="23.79" y="4.21" width="1" height="2"
                                  transform="translate(3.43 18.7) rotate(-45)" stroke="#E3B624"
                                  stroke-linecap="round" stroke-linejoin="round" stroke-width="0.5"/>
                            <path d="M24.28,3h1.5a1,1,0,0,1,1,1V4a1,1,0,0,1-1,1h-1.5a0,0,0,0,1,0,0V3A0,0,0,0,1,24.28,3Z"
                                  transform="translate(4.67 19.21) rotate(-45)" fill="none" stroke="#E3B624"
                                  stroke-linecap="round" stroke-linejoin="round" stroke-width="0.5"/>
                        </g>
                    </g>
                </svg>
                <h1 class="font-hairline text-xl text-center mt-6">Grafika</h1>
            </figure>
            <figure v-else class="shadow-md card flex flex-col justify-center w-full h-full bg-v-yellow" key="back">
                <span class="font-light xl:font-hairline font-fira text-white leading-normal p-8">Online és offline grafika - kivitelezéssel. Weben megjelenő és nyomdai termékek kreatív elemeinek széles választéka - bannerek, marketing anyagok, arculati elemek, logó, névjegykártya, levélpapír, boríték, brossúra, katalógus, szóróanyagok…
                </span>
            </figure>
        </transition>
    </div>

</template>

<script>
export default {
  props: ['svg', 'appear'],
  data () {
    return {
      flip: true
    }
  }
}
</script>

<style lang="scss" scoped>
    .outlineAnimation {
        stroke-dasharray: 1000;
        stroke-dashoffset: 0;
        animation: icon-animate-in 2s cubic-bezier(0.95, 0.05, 0.795, 0.035);
    }

    @keyframes icon-animate-in {
        0% {
            stroke-dashoffset: 1000;
        }
        100% {
            stroke-dashoffset: 0;
        }
    }

    figure {
        border-radius: 10px;
    }

    svg {
        height: 5rem;
        fill: #E3B624;
    }

    .flip-enter-active, .flip-leave-active {
        transition: all 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94);
    }

    .flip-enter, .flip-leave-to {
        transform: rotateY(90deg);
        opacity: 0;
    }

</style>



// WEBPACK FOOTER //
// src/components/Grafika.vue